
import actions from './moduleTransaksiActions.js'
import state from './moduleTransaksiState.js'
import mutations from './moduleTransaksiMutations'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
